import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router/composables';
    import emitter from '@/utils/mitt';
    import { alertError } from '@/utils/dialogs';
    import { ToastProgrammatic as Toast } from 'buefy';
    import { THGTag, THGUpdateTagData } from '@/interfaces/thg/THGTag';
    import { fetchTHGTag, saveTHGTag } from '@/api/thg/tags';
    import THGTagForm from '@/components/thg/tags/THGTagForm.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTag',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();
    const tag = ref<THGTag | null>(null);

    async function saveTag() {
        if (!tag.value) {
            throw new Error('tag is undefined');
        }

        emitter.emit('showLoader');

        // create the update data
        const updateData: THGUpdateTagData = {
            category: tag.value.category,
            name: tag.value.name,
            color_rgb: tag.value.color_rgb,
        };

        if (!tag.value._id) {
            throw new Error('Tag ID is undefined');
        }

        // do the actual update
        const response = await saveTHGTag(tag.value._id, updateData);

        if (response.status !== 200) {
            if (response.status === 409) {
                alertError(
                    'Fehler',
                    `Ein Tag mit dem Namen <b>${updateData.name}</b> existiert bereits.`,
                );
            } else {
                alertError('Fehler', 'Fehler beim Speichern des Tags.');
            }
        } else {
            Toast.open({ type: 'is-success', message: 'Tag erfolgreich gespeichert.' });
            router.push({ name: 'thgtagslist' });
        }

        emitter.emit('hideLoader');
    }

    onMounted(async () => {
        const response = await fetchTHGTag(route.params.tagId);
        const tagObj = response.parsedBody;

        if (!tagObj) {
            throw new Error('Error while fetching tag.');
        }

        tag.value = tagObj;
    });

return { __sfc: true,route, router, tag, saveTag, THGTagForm }
}

})